var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { isRelativeUrl } from "./UrlUtils.js";
import buildQuery from "odata-query";
const dummyOrigin = "http://dummy.com/";
const buildOdataQuery = (odataQueryOptions, config) => {
  const { baseUrl = "", cleanOdataDollarSignPrefix = false, additionalQueryParams: queryParams = {} } = __spreadValues({}, config);
  const isRelative = isRelativeUrl(baseUrl);
  const hasLeadingSlash = isRelative && baseUrl.startsWith("/");
  const url = isRelative ? new URL(baseUrl, dummyOrigin) : new URL(baseUrl);
  if (!!odataQueryOptions) {
    const odataQuery = buildQuery(odataQueryOptions);
    const odataUrl = new URL(odataQuery, dummyOrigin);
    odataUrl.searchParams.forEach((value, key) => {
      const cleanedKey = cleanOdataDollarSignPrefix ? key.replace(/^\$/, "") : key;
      url.searchParams.set(cleanedKey, value);
    });
  }
  if (!!queryParams && Object.keys(queryParams).length > 0) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }
  const urlString = url.toString();
  const cleanedUrlString = isRelative ? urlString.replace(dummyOrigin, hasLeadingSlash ? "/" : "") : urlString;
  return decodeURIComponent(cleanedUrlString);
};
export {
  buildOdataQuery
};
//# sourceMappingURL=ODataUtils.js.map
